/**
 * 部门稿库左侧导航
 * 2019-6-27
 * Bai.Zhiming
 */
angular.module("departmentLeftModule", []).
directive("departmentLeft", ["$state", "$timeout", function($state, $timeout) {
    return {
        replace: true,
        restrict: "E",
        scope: {
            departMentList: "="
        },
        templateUrl: "./editingCenter/iWo/left/departmentLeft/departmentLeft_tpl.html",
        link(scope, $element, $attrs) {
            initStatus();
            /**
             * [autoLocation description] 自动定位
             * @return {[type]} [description]
             */
            function autoLocation() {
                let timer = $timeout(() => {
                    let routerArray = $state.current.name.split(".");
                    if (routerArray.length < 4 || routerArray[3] != 'departmentManuscript') {
                        scope.status.expandedNodes.push(scope.departMentList[0].DEPARTMENTALDOCID);
                        scope.status.selectedNode = scope.departMentList[0].CHILDREN[0].DEPARTMENTALDOCID;
                        scope.selectLeve4(scope.departMentList[0].CHILDREN[0].DEPARTMENTALDOCID, scope.departMentList[0].DEPARTMENTALDOCID, );
                        return;
                    }
                    let id = $state.params.departmentDocId;
                    let parentId = $state.params.parentid;
                    scope.status.expandedNodes.push(parentId);
                    scope.status.selectedNode = id;
                },500);
                scope.$on("$destroy", () => {
                    $timeout.cancel(timer);
                });
            }
            /**
             * [openNode description] 展开节点
             * @param  {[type]} parentId [description] 被展开的节点id
             * @return {[type]}      [description]
             */
            scope.openNode = function(parentId) {
                let nodeInfo = scope.isOpen(parentId);
                if (nodeInfo.flag) {
                    scope.status.expandedNodes.splice(nodeInfo.index, 1);
                } else {
                    scope.status.expandedNodes.push(parentId);
                }
            };
            /**
             * [selectLeve4 description] 选中部门稿库
             * @param  {[type]} id       [description] 节点id
             * @param  {[type]} parentId [description] 父节点id
             * @return {[type]}            [description]
             */
            scope.selectLeve4 = function(id, parentId) {
                let router = "front.editctr.iWo.departmentManuscript";
                $state.go(router, { departmentDocId: id, parentid: parentId }, { reload: router });
                scope.status.selectedNode = id;
            }
            /**
             * [isOpen description] 判断节点是否展开
             * @param  {[type]}  parentId [description] 被验证的节点id
             * @return {Boolean}      [description]
             */
            scope.isOpen = function(parentId) {
                let flag = {
                    flag: false
                };
                for (let i = 0; i < scope.status.expandedNodes.length; i++) {
                    if (scope.status.expandedNodes[i] == parentId) {
                        return {
                            flag: true,
                            index: i
                        }
                    }
                }
                return flag;
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    expandedNodes: []
                };
                autoLocation();
            }
        }
    };
}])